<template>
  <div class="home">
    <div class="wd-login">
      <el-input placeholder="您注册时用的账号" v-model="u_phone">
        <template slot="prepend">账号名</template>
      </el-input>
      <el-input placeholder="请输入密码" v-model="u_pass" show-password style="margin:10px 0 0 0">
        <template slot="prepend">密码</template>
      </el-input>
      <div style="margin:6px 0 15px 0;text-align: right;">
        <!-- <el-button type="text" size="mini" style="color:#b5a16b"  disabled>忘记密码？</el-button> -->
      </div>
      <el-button type="primary" style="width:100%;margin-top: 10px;" @click="handleWDLogin">登录</el-button>
      <div class="copy_right">v5.6 &copy; subudian.com</div>
    </div>

    <div class="icp_show">
      <div class="foot_logo"><img src="~@/assets/foot_logo.png" ></div>
      <a href="https://beian.miit.gov.cn" target="_blank">京ICP备2022034630号-2</a>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import CommonNav from "@/components/Nav.vue";
import CommonHeader from "@/components/Header.vue";
import * as MN from '@/api/common'
export default {
  name: 'loginView',
  data(){
    return{
      u_phone: '',
      u_pass: '',
    }
  },
  components: {
		CommonNav,
		CommonHeader
	},
  methods:{
    handleWDLogin(){
      if ( !this.u_phone || !this.u_pass ){
        this.$message({
          message: '请输入账号名和密码',
          type: 'warning'
        });
        return
      }
      let post={
				u_phone:this.u_phone,
        u_pass:this.u_pass
			}
      let me = this;
      MN.checkLogin(post).then(res => {

         if( res.status == 'login_ok' ){
          sessionStorage.setItem('subudian_token',res.token);
          me.$router.push({
            path: "/topics",
          });
          return
        }

        if( res.status == 'ban_user' ){
          me.$message({
            message: '您的账户已停用',
            type: 'warning'
          });
          return
        }

        me.$message({
          message: '密码或账号名错误',
          type: 'warning'
        });
      
				// if( res == 'admin_user' ){
        //   me.$router.push({
        //     path: "/topics",
        //   });
        //   return
        // }

        // if( res == '2025brandcase' ){
        //   me.$router.push({
        //     path: "/brandcasedetail?uuid=68EA3E4A5A0C37EA6C631195241798C4",
        //   });
        //   return
        // }

        // if( res == '2025innovate' ){
        //   me.$router.push({
        //     path: "/viewdetail?uuid=68EA3E241798A0C37EA6C6C453119511",
        //   });
        //   return
        // }

				// if( res == '2024jkb_collect_user' ){
        //   me.$router.push({
        //     path: "/jkblist?uuid=E4AC4555417A11956837C4E4AA153EA3",
        //   });
        //   return
        // }


        // if( res == 'specialist_user' ){
        //   me.$router.push({
        //     path: "/gradelist?uuid=68EA3E4A531195C4E4A17A0C37C4E4A1",
        //   });
        //   return
        // }

        // if( res == 'ten_list' ){
        //   me.$router.push({
        //     path: "/tenlist?uuid=qFI7jad0SuGibCAfJ2HMep5mUxtKYV81kholvON",
        //   });
        //   return
        // }

        
          
        
			})

    }
  }
  
}
</script>
<style scoped>

.foot_logo{ margin-bottom: 8px; }
.foot_logo img{ width: 110px; }

.icp_show a{ text-decoration: none;color: #f0f0f0; }

.icp_show{
  z-index: 0;
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 50px;
  color: #f6f6f6;
  text-align: center;
  font-size: 12px;
}

.home{
  position: fixed;
  width: 100%;
  height: 100%;
  background:url('~@/assets/bg1.jpg') no-repeat top #cccccc;
  background-size: 115% 115%;
  background-position:0 0;
  /* animation-name: feather_3;  
  animation-duration:3s; 
  animation-iteration-count:111;
  animation-timing-function:ease-out; 
  animation-direction:alternate; 
  animation-fill-mode:forwards; */
/*  
  background-color: #EFEFEF; */
}
.wd-login{
  width: 350px;
  padding: 50px;
  /* border: 1px solid #e6e6e6; */
  background-color: #ffffff;
  opacity: 0.98;
  border-radius: 10px;
  margin: 0 auto;
  margin-top: 200px;
  position: relative;
  box-shadow: 4px 6px 48px #d4f0ff;
}
.copy_right{
  position: absolute; 
  right: 50px;
  bottom: 10px;
  color: #b0b0b0;
  font-size: 12px;
}

@keyframes feather_3 {
    0% { background-size: 120% 120%;}
    100% { background-size: 170% 170%;}
}

</style>
